import { useTranslation } from "react-i18next"
import { Users } from "lucide-react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"

const DriverManagementSidebarButton = ({
  className,
}: {
  className?: string
}) => {
  const { t } = useTranslation()
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.DRIVER_MANAGEMENT}
      icon={Users}
      activeIcon={Users}
      tooltipText={t("app.sidebar.driverManagement")}
      className={className}
    />
  )
}

export default DriverManagementSidebarButton
